module.exports = __webpack_public_path__ + "img/icon3.f10d54c1.png";